import { render, staticRenderFns } from "./EmailClassificationAddView.vue?vue&type=template&id=747a953a"
import script from "./EmailClassificationAddView.vue?vue&type=script&lang=js"
export * from "./EmailClassificationAddView.vue?vue&type=script&lang=js"
import style0 from "./EmailClassificationAddView.vue?vue&type=style&index=0&id=747a953a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports